import React, { useState } from "react";
import { LoginScreen } from "./LoginScreen";
import { LoginCodeScreen } from "./LoginCodeScreen";

export function LoginFlow() {
  const [showCodeEntry, setShowCodeEntry] = useState(false);

  return (
    <>
      {!showCodeEntry ? (
        <LoginScreen onNavigateToCodeEntry={() => setShowCodeEntry(true)} />
      ) : (
        <LoginCodeScreen
          showSuccessMessage={true}
          onNavigateBack={() => setShowCodeEntry(false)}
        />
      )}
    </>
  );
}
